import Cookies from 'universal-cookie';
import momentTimezone from 'moment-timezone';
import { isEmpty } from 'lodash';

const getHostCalendarScheduleResponse = (response) => {
  if (isEmpty(response?.schedules)) return [];

  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  return response?.schedules?.map((schedule) => {
    return {
      id: schedule?.id,
      title: schedule?.title,
      eventName: schedule?.title,
      start: momentTimezone.tz(schedule?.startedAt, timezone).format('YYYY-MM-DD HH:mm:ss'),
      end: momentTimezone.tz(schedule?.endedAt, timezone).format('YYYY-MM-DD HH:mm:ss'),
      type: schedule?.scheduleType,
      hosts: schedule?.hosts,
      accounts: schedule?.accountLivestreams,
      operators: schedule?.operators,
      studio: schedule?.studio,
      reason: schedule?.reason,
    };
  });
};

export default getHostCalendarScheduleResponse;
